<template>
	<div>
		<!-- 移动端抽屉按钮（仅移动端显示） -->
		<button
			class="mobile-drawer-btn"
			@click.stop="toggleDrawer"
			v-show="isMobile"
		>
			☰
		</button>

		<!-- 原有内容保持不变 -->
		<div class="topTitle blocks">
			<div class="logoBlock">
				<img
					style="
						margin-right: 53px;
						margin-top: 41px;
						margin-bottom: 42px;
					"
					src="../../assets/imgs/southernStudies/logo_nf.png"
					alt=""
				/>
				<div class="taglist">
					<a
						href="javascript:void(0);"
						class="tag"
						style="color: #1b70cb"
						>中文</a
					>
					<span style="color: #9e9e9e">|</span>
					<a target="_blank" class="tag" href="/en">English</a>
				</div>
			</div>
			<div class="header-nav-box">
				<div class="header-nav">
					<div class="header-nav-items">
						<div
							v-for="(item, index) in sectionList"
							:key="index"
							class="header-nav-item"
							:class="{ active: isActive(item) }"
							@click="goSection(item)"
						>
							{{ item.name }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 移动端抽屉遮罩 -->
		<div
			class="drawer-mask"
			v-show="isMobile && isDrawerOpen"
			@click="toggleDrawer"
		></div>

		<!-- 移动端抽屉导航（复用原有导航列表） -->
		<div
			class="mobile-drawer"
			:class="{ 'drawer-open': isMobile && isDrawerOpen }"
			v-show="isMobile"
		>
			<div
				class="drawer-nav-item"
				v-for="(item, index) in sectionList"
				:key="index"
				:class="{ active: isActive(item) }"
				@click="handleDrawerNavClick(item)"
			>
				{{ item.name }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			sectionList: [
				{ name: '首页', linkName: 'home' },
				{ name: '宗旨与职责', linkName: 'intro' },
				{ name: '理事会', linkName: 'council' },
				{ name: '研究报告', linkName: 'report' },
				{ name: '近期活动', linkName: 'activity' },
			],
			isMobile: false, // 是否为移动端
			isDrawerOpen: false, // 抽屉是否打开
		};
	},
	created() {
		// 检测设备类型
		this.checkMobile();
		// 监听窗口大小变化
		window.addEventListener('resize', this.checkMobile);
	},
	destroyed() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		// 检测是否为移动端（750px以下）
		checkMobile() {
			this.isMobile = window.innerWidth <= 750;
		},
		// 切换抽屉显示/隐藏
		toggleDrawer() {
			this.isDrawerOpen = !this.isDrawerOpen;
			// 阻止/恢复页面滚动
			document.body.style.overflow = this.isDrawerOpen ? 'hidden' : '';
		},
		// 抽屉导航点击事件
		handleDrawerNavClick(item) {
			this.goSection(item);
			this.toggleDrawer(); // 点击后关闭抽屉
		},
		// 原有方法保持不变
		goSection(item) {
			if (this.$route.name === 'cn') {
				if (item.name === '首页') return;
				this.scrollToSection(item.linkName);
			} else {
				if (item.name === '首页') {
					this.$router.push({ name: 'cn' });
				} else {
					this.$router.push({
						name: 'cn',
						query: { section: item.linkName },
					});
				}
			}
		},
		scrollToSection(sectionId) {
			this.$nextTick(() => {
				const el = document.getElementById(sectionId);
				if (el) {
					el.scrollIntoView({ behavior: 'smooth' });
					el.classList.add('highlight');
					setTimeout(() => {
						el.classList.remove('highlight');
					}, 2000);
				}
			});
		},
		isActive(item) {
			// 原有首页高亮逻辑
			if (
				(this.$route.name === 'detailsSouthern' ||
					this.$route.name === 'cn') &&
				item.name === '首页'
			) {
				return true;
			}

			// 研究报告高亮逻辑（兼容路由path和查询参数）
			const isReportListRoute = this.$route.path === '/cn/reportList';
			const isReportQuery =
				this.$route.name === 'cn' &&
				this.$route.query.section === 'report';

			if (
				item.linkName === 'report' &&
				(isReportListRoute || isReportQuery)
			) {
				return true;
			}

			// 近期活动高亮逻辑
			const isActivityListRoute =
				this.$route.path === '/cn/activityList';
			const isActivityQuery =
				this.$route.name === 'cn' &&
				this.$route.query.section === 'activity';

			if (
				item.linkName === 'activity' &&
				(isActivityListRoute || isActivityQuery)
			) {
				return true;
			}

			return false;
		},
	},
};
</script>

<style lang="less" scoped>
// 原有样式保持不变
.topTitle {
	height: 220px;
	.logoBlock {
		max-width: 1366px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		.taglist {
			line-height: 166px;
			display: flex;
			.tag {
				padding: 0 15px;
				font-size: 16px;
				font-weight: 400;
				color: #9e9e9e;
				cursor: pointer;
			}
		}
	}
}
.header-nav-box {
	background: #0072b5;
	.header-nav {
		max-width: 1366px;
		height: 51px;
		margin: 0 auto;
		position: relative;
		display: flex;
	}
	.header-nav-items {
		display: flex;
		.header-nav-item {
			font-weight: 600;
			height: 51px;
			font-size: 20px;
			width: 195px;
			color: #ffffff;
			line-height: 51px;
			float: left;
			text-align: center;
			border-right: 1px solid #fff;
			cursor: pointer;
			transition: background 0.3s;
		}
		.header-nav-item:last-child {
			border-right: none;
		}
		.header-nav-item:hover {
			background: #005998;
		}
		.header-nav-item.active {
			background: #005998; // 高亮背景
		}
	}
}

// 新增移动端适配样式（不影响原有样式）
@media screen and (max-width: 769px) {
	// 隐藏原有导航栏
	.topTitle {
		.header-nav-box {
			display: none !important;
		}
		// 调整logo区域适配移动端
		.logoBlock {
			width: 100% !important;
			padding: 0 15px !important;
			img {
				margin: 20px 0 !important;
				height: 65px !important;
				width: auto !important;
			}
			.taglist {
				line-height: 110px !important;
				.tag {
					font-size: 14px !important;
					padding: 0 8px !important;
				}
			}
		}
		height: auto !important;
	}

	// 移动端抽屉按钮（固定左上角）
	.mobile-drawer-btn {
		position: fixed !important;
		top: 15px !important;
		right: 15px !important;
		width: 34px !important;
		height: 34px !important;
		background: #0072b5 !important;
		color: #fff !important;
		border: none !important;
		border-radius: 4px !important;
		font-size: 20px !important;
		cursor: pointer !important;
		z-index: 9999 !important;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
	}

	// 抽屉遮罩
	.drawer-mask {
		position: fixed !important;
		top: 0 !important;
		left: 0 !important;
		right: 0 !important;
		bottom: 0 !important;
		z-index: 9998 !important;
	}

	// 移动端抽屉导航
	.mobile-drawer {
		position: fixed !important;
		top: 0 !important;
		left: 0 !important;
		width: 260px !important;
		height: 100vh !important;
		background: #fff !important;
		z-index: 9999 !important;
		transform: translateX(-100%) !important;
		transition: transform 0.3s ease !important;
		padding-top: 70px !important;
		box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1) !important;

		&.drawer-open {
			transform: translateX(0) !important;
		}

		.drawer-nav-item {
			height: 50px !important;
			line-height: 50px !important;
			padding: 0 20px !important;
			font-size: 16px !important;
			color: #333 !important;
			border-bottom: 1px solid #f5f5f5 !important;
			cursor: pointer !important;

			&.active {
				background: #edf4fa !important;
				color: #0072b5 !important;
				font-weight: 600 !important;
			}

			&:hover {
				background: #f8f8f8 !important;
			}
		}
	}
}

// 大屏隐藏抽屉相关元素
@media screen and (min-width: 751px) {
	.mobile-drawer-btn,
	.mobile-drawer,
	.drawer-mask {
		display: none !important;
	}
}
</style>
